import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: {
        '++': [
          {
            '@$': 'financialVolume',
          },
          ' Expense by Department',
        ],
      },
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  slices: {
                    '@': 'expenseQuery',
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          segmentId: 'org',
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
  subqueries: {
    expenseQuery: {
      sort: {
        by: {
          '??': [
            {
              '+': {
                '@': 'expenses',
              },
            },
            0,
          ],
        },
        descending: true,
      },
      target: 'ent:!org:!dept',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          value: {
            '??': [
              {
                '+': {
                  '@': 'expenses',
                },
              },
              0,
            ],
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              orgEntityId: {
                                '@_': 'id',
                              },
                              orgRecordId: {
                                '@.': '!id',
                              },
                            },
                          },
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        expenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@': 'isInMtdc',
                },
              ],
              true,
            ],
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        projectAssignments: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          target: 'ent:!projects:!proj',
        },
      },
    },
  },
}
